import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

/**
 * Redirect component for Admin Booking Config when user doesn't have permission
 * 
 * This component handles unauthorized access to the Admin Booking Configuration page.
 * It displays an error message and redirects the user to the dashboard.
 * 
 * @param {Object} props - Component props
 * @param {Function} props.message - Message API function from MessageProvider for showing toast notifications
 * @returns {JSX.Element} Navigate component that redirects to dashboard
 */
const AdminBookingConfigRedirect = ({ message }) => {
  useEffect(() => {
    if (message) {
      message.error("You don't have permission to access Admin Booking Configuration.", 3);
    }
  }, [message]);

  return <Navigate to="/dashboard" replace />;
};

export default AdminBookingConfigRedirect;
